import axios from "axios";
import { GlobalData } from "serverData";
import _ from "libs/lodash";

let ServiceCall = function(
  url,
  params,
  cancelToken,
  baseUrl,
  method,
  dataObj,
  sessionExpiredRedirectURL,
  headers
) {
  let targetUrl = _.isNil(baseUrl)
    ? GlobalData.servicesBaseUrl + url
    : baseUrl + url;

  let defaultHeaders = {};

  // support multiple param objects (querystring) in an array (merge them)
  let requestParams = {};
  if (_.isArray(params)) requestParams = _.merge({}, ...params);
  else requestParams = params;

  let request = {
    method: method ? method : "get",
    url: targetUrl,
    params: requestParams,
    data: dataObj
  };

  if (cancelToken) request["cancelToken"] = cancelToken;
  if (request.method.toLowerCase() === "post")
    //TODO: for future refactoring to support json post
    defaultHeaders = {
      "Content-Type": "application/x-www-form-urlencoded"
    };

  request["headers"] = { ...defaultHeaders, ...headers };

  return new Promise(function(resolve, reject) {
    axios(request)
      .then(function(response) {
        // if empty response return error
        if (_.isEmpty(response.data))
          return reject(`Empty response (${targetUrl})`);

        //check if session expired
        if (response.data.Result && response.data.Result.resultCode === "401") {
          if (sessionExpiredRedirectURL) {
            //For sessions that span accross multiple pages (URLs) If the session
            //expires on the second URL redirect him to the first page
            window.location = sessionExpiredRedirectURL;
          } else {
            //reload page in order for server to handle the actual redirection to login page
            window.location.href = "/ssopages/logoutsso.html";
          }
          return;
        }

        // success
        return resolve(response.data);
      })
      .catch(error => {
        // don't return error if ajax request is canceled
        if (!axios.isCancel(error)) {
          return reject(error);
        }
      });
  });
};

export default ServiceCall;
